/**
 * 消息组类型
 */
export enum MessageGroupTypeEnum {
    /**
     * 超级消息组类型(用来发送到后台)
     */
    SUPER_SYSTEM = "SUPER_SYSTEM",
    /**
     * 系统级别消息，一般是用来群发
     */
    SYSTEM = "SYSTEM",
}

/**
 * 系统级别消息类型
 */
export enum MessageSuperSystemNoticeTypeEnum {
    /**
     * 用户充值通知
     */
    UserRechargeNotice = "UserRechargeNotice",
    /**
     * 用户提现通知 
     */
    UserWithdrawNotice = "UserWithdrawNotice",
    /**
     * AI订单通知
     */
    AiOrderSubmitted = "AiOrderSubmitted",
    /**
     * 合约订单通知
     */
    ContractOrderSubmitted = "ContractOrderSubmitted",
    /**
     * 期权订单通知
     */
    OptionsOrderSubmitted = "OptionsOrderSubmitted",
    /**
     * 现货订单通知
     */
    SpotOrderSubmitted = "SpotOrderSubmitted",
}

/**
 * 客户端系统系别通知消息
 */
export enum MessageSystemNoticeTypeEnum {
    /**
     * 系统消息变更
     */
    ConfigUpdated = "ConfigUpdated",
    /**
     * 公告变更通知
     */
    NoticeUpdate = "NoticeUpdate",
    /**
     * 实时行情数据
     */
    RealTimeKLineData = "RealTimeKLineData",
    /**
     * 发送实时买卖数据
     */
    TradeDetailData = "TradeDetailData"
}

/**
 * 客户端用户级别通知消息
 */
export enum MessageUserNoticeTypeEnum {
    /**
     * 更新用户配置
     */
    UserInfoUpdated = "UserInfoUpdated",
    /**
     * 发送期权结算
     */
    OptionSettlement = "OptionSettlement",
    /**
     * 发送余额变更
     */
    UserBalanceUpdated = "UserBalanceUpdated",
    /**
     * 发送系统任务统计
     */
    TaskStatistics = "TaskStatistics",
    /**
     * 发送任务事件
     */
    TaskWorkEvent = "TaskWorkEvent"
}
